<template>
  <div class="body1">
    <div class="content">
      <div class="title">WHO IS ELE EDUCATION</div>
      <div class="desc">Ele Education is a global English program for children aged 2-12.<br/>Improve listening, speaking, reading and writing skills, with focus on the improvement of English application skills for different ages.<br/>Over the past 40 years, our Unique E-Blocks Teaching Program is widely used in more than 17,000 schools, spanning 20 countries, benefiting<br/>over 400 thousand children. </div>
      <img class="img" src="../../assets/body1-num.png">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {

  },
  methods: {}
}
</script>


<style scoped lang="less">
@import "../../assets/style/index";
.body1{
  height: 626px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background: url("../../assets/body1-bg.png") no-repeat;
  background-size: auto 100%;
  .content{
    .media-content;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;
    .title{
      color: #674789;
      font-size: 38px;
      font-family: 'Adobe Heiti Std', Helvetica, Arial, sans-serif;
      line-height: 50px;
    }
    .desc{
      margin-top: 36px;
      margin-bottom: 56px;
      text-align: center;
      color: #626262;
      font-size: 18px;
      line-height: 30px;
      font-family: 'ArialMT', Helvetica, Arial, sans-serif;
    }
    .img{
      width: 100%;
      object-fit: contain;
      height: 171px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index/e-body1.vue